import { DateTimePicker } from "@mantine/dates";
import { useState } from "react";
import { EditProps } from "./util";
export interface Option {
  label: string;
  value: any;
}
export interface EditSelectProps extends EditProps {
  minDate?: Date;

  dropdownType?: "popover" | "modal";
}
const DateTimeProp = ({
  object,
  prop,
  mutate,
  label,
  minDate,
  disabled,
  dropdownType,
}: EditSelectProps) => {
  // const { t } = useTranslation();
  const initDate = object[prop] ? new Date(object[prop]) : null;
  const [dateTime, setDateTime] = useState<Date | null>(initDate);
  // console.log("time :", time);
  const onChange = (value: Date | null) => {
    // console.log("onChange :", value);
    const dto: any = {
      _id: object._id,
    };
    dto[prop] = value;
    mutate(dto, {
      // onSuccess: () =>
      //   showNotification({
      //     message: t("Saved"),
      //     autoClose: true,
      //     color: "success",
      //   }),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  const doSetDateTime = (date: Date | null) => {
    setDateTime(date);
    onChange(date);
  };
  return (
    <DateTimePicker
      dropdownType={dropdownType}
      disabled={disabled}
      label={label}
      placeholder="Pick date and time"
      value={dateTime}
      onChange={(e) => doSetDateTime(e)}
      minDate={minDate}
    />
  );
};
export default DateTimeProp;
